import styled, { css } from 'styled-components';
import { CarvanaTheme, getMediaQuery } from '@carvana/showroom-theme';


export const Wrapper = styled.div``;

export const SliderContainer = styled.div`
  width: 100%;

  [type='range']::-ms-thumb {
    margin-top: 0;
    box-sizing: border-box;
    width: 2em;
    height: 2em;
    border-radius: 50%;
    background: #fff;
    border: 3px solid ${props => props.theme.carvana.blue};
  }
`;

export const SliderThumb = css`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #fff;
  border: 1px solid ${props => props.theme.carvana.blue.primary};
  cursor: grab;
  z-index: 10;

  &:active {
    cursor: grabbing;
  }
`;

export const Slider = styled.input.attrs({ type: 'range' })`
  -webkit-appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  position: relative;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    background: transparent;
    height: 1.8rem;
  }

  &:hover {
    opacity: 1;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    ${SliderThumb};

    /* &::before {
      background-color: red;
    } */
  }

  &::-webkit-slider-runnable-track {
    /* height: 7px; */
    /* background: red;
    content: '';
    */
    /* pointer-events: none; */
    /* width: 300px; */
    /* height: 5px;
    background: red;
    border: none;
    border-radius: 3px; */
  }

  &::-moz-range-thumb {
    ${SliderThumb};
  }

  /* &::-webkit-progress-value {
    background-color: orange;
  } */

  &::-moz-range-track {
    /* common styles */
  }

  &::-moz-focus-outer {
    border: 0;
  }

  &::-ms-track {
    color: transparent;
    background: #d3d3d3;
    border-radius: 5px;
    background-color: #d3d3d3;
  }

  &::-ms-ticks-after {
    display: none;
  }

  &::-ms-ticks-before {
    display: none;
  }

  &::-ms-fill-lower {
    background: transparent;
  }

  &::-ms-fill-upper {
    background: transparent;
  }

  &::-ms-thumb {
    ${SliderThumb};
    margin-top: 0;
    box-sizing: border-box;
    width: 2em;
    height: 2em;
    border-radius: 50%;
    background: #fff;
    border: 3px solid ${props => props.theme.color.primary.v600};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 1.5rem;
`;

export const ContentLeft = styled.div`
  font-weight: 700;
  color: ${props => props.theme.color.primary.v600};
  font-size: 1rem;
`;

export const ContentRight = styled.div`
  font-size: 18px;
  color: ${props => props.theme.color.primary.v600};
  font-weight: 700;
`;

export const SliderValuesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 1rem;
`;

export const SliderValues = styled.div`
  font-size: 12px;
  color: ${props => props.theme.color.neutral.v400};
`;